/* assets/3d-visualization-downstream.js — 3D-READINESS-BRIDGE-05 */
(function () {
  'use strict';

  var VERSION = '2026-08-07-3d-readiness-bridge-05';
  if (window.__THREE_D_VISUALIZATION_DOWNSTREAM_VERSION__ === VERSION) return;
  window.__THREE_D_VISUALIZATION_DOWNSTREAM_VERSION__ = VERSION;

  var ROOT_SELECTOR = '[data-3d-downstream]';

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function qs() {
    return new URLSearchParams(window.location.search || '');
  }

  function setText(el, value) {
    if (el) el.textContent = String(value == null ? '' : value);
  }

  function boolAttr(root, name) {
    return root.getAttribute(name) === 'true';
  }

  function numberAttr(root, name) {
    var value = Number(root.getAttribute(name));
    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function message(root, key, fallback) {
    var value = root && root.dataset
      ? root.dataset['downstreamMessage' + key]
      : '';
    return clean(value) || fallback;
  }

  function currentContext(root) {
    var params = qs();
    var source = params.get('source') || 'spatial-os';
    var intent = params.get('intent') || params.get('scenario') || '3d-readiness';
    var endpoint = root.getAttribute('data-canonical-endpoint') || '/api/map/run';

    return {
      source: source,
      intent: intent,
      context_kind: clean(root.getAttribute('data-downstream-context')) || 'page',
      api_family: root.getAttribute('data-api-family') || 'gcity-platform',
      canonical_endpoint: endpoint,
      engine_type: root.getAttribute('data-engine-type') || 'map',
      delivery_type: root.getAttribute('data-delivery-type') || 'tool',
      delivery_method: root.getAttribute('data-delivery-method') || 'instant',
      result_surface: root.getAttribute('data-result-surface') || 'panel',
      api_trigger_enabled: boolAttr(root, 'data-api-trigger-enabled'),
      requires_gfun: boolAttr(root, 'data-requires-gfun'),
      requires_entitlement: boolAttr(root, 'data-requires-entitlement'),
      gfun_consume_per_call: numberAttr(root, 'data-gfun-consume-per-call'),
      product_handle: clean(root.getAttribute('data-product-handle')),
      review_route: root.getAttribute('data-review-route') || ''
    };
  }

  function renderContext(root, ctx) {
    setText(root.querySelector('[data-3d-source]'), ctx.source);
    setText(root.querySelector('[data-3d-intent]'), ctx.intent);
    setText(root.querySelector('[data-3d-api]'), ctx.canonical_endpoint);
  }

  function buildExecutionContext(ctx) {
    return {
      api_family: ctx.api_family,
      canonical_endpoint: ctx.canonical_endpoint,
      delivery_type: ctx.delivery_type,
      delivery_method: ctx.delivery_method,
      engine_type: ctx.engine_type,
      result_surface: ctx.result_surface,
      requires_gfun: ctx.requires_gfun,
      requires_entitlement: ctx.requires_entitlement,
      gfun_consume_per_call: ctx.gfun_consume_per_call,
      gfun_reward_on_completion: 0,
      data: {
        source: ctx.source,
        intent: ctx.intent,
        context_kind: ctx.context_kind,
        product_handle: ctx.product_handle || null,
        downstream: ctx.context_kind === 'product' && ctx.product_handle
          ? ctx.product_handle
          : 'spatial-intelligence',
        readiness_only: true,
        live_3d_renderer: false,
        formal_report: false,
        review_route: ctx.review_route
      }
    };
  }

  function setStatus(root, value) {
    setText(root.querySelector('[data-3d-api-status]'), value);
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function executePreview(root, button) {
    var ctx = currentContext(root);
    renderContext(root, ctx);

    if (!ctx.api_trigger_enabled) {
      setStatus(
        root,
        message(
          root,
          'ApiDisabled',
          'Local 3D workflow readiness preview shown. API execution is not enabled for this context.'
        )
      );
      return;
    }

    if (!window.GCityExecutor || typeof window.GCityExecutor.execute !== 'function') {
      setStatus(
        root,
        message(
          root,
          'ExecutorUnavailable',
          'Local 3D workflow readiness preview shown. The canonical executor is unavailable.'
        )
      );
      return;
    }

    setBusy(button, true);
    setStatus(root, message(root, 'Checking', 'Checking 3D workflow readiness…'));

    Promise.resolve()
      .then(function () {
        return window.GCityExecutor.execute(buildExecutionContext(ctx));
      })
      .then(function (result) {
        if (!result || typeof result !== 'object' || result.ok === false || result.success === false || result.blocked === true) {
          setStatus(
            root,
            message(
              root,
              'Unauthorized',
              'Local readiness preview shown. The canonical executor did not authorize a live result.'
            )
          );
          return;
        }

        setStatus(
          root,
          message(
            root,
            'Checked',
            '3D workflow readiness checked. Continue to GCityPartners for scoped review.'
          )
        );
      })
      .catch(function () {
        setStatus(
          root,
          message(
            root,
            'NetworkUnavailable',
            'Local readiness preview shown. Network or executor validation is unavailable.'
          )
        );
      })
      .then(function () {
        setBusy(button, false);
      });
  }

  function mount(root) {
    if (!root || root.getAttribute('data-3d-downstream-mounted') === 'true') return;
    root.setAttribute('data-3d-downstream-mounted', 'true');
    root.setAttribute('data-3d-readiness-runtime', VERSION);

    renderContext(root, currentContext(root));

    var button = root.querySelector('[data-3d-free-preview]');
    if (button) {
      button.setAttribute('aria-busy', 'false');
      button.addEventListener('click', function () {
        executePreview(root, button);
      });
    }
  }

  function mountAll(scope) {
    var root = scope || document;

    if (root.matches && root.matches(ROOT_SELECTOR)) {
      mount(root);
    }

    root.querySelectorAll(ROOT_SELECTOR).forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(document); }, { once: true });
  } else {
    mountAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    mountAll(event.target || document);
  });
})();